import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useStepCycle } from '../../hooks/useStepCycle';
import { EASE_OUT } from '../../utils/motion';
const features = [{
  label: 'Benutzer & Rollen',
  by: 'intigoo'
}, {
  label: 'Auftragsübersicht',
  by: 'kunde'
}, {
  label: 'Lagerbestand',
  by: 'intigoo'
}, {
  label: 'ERP-Schnittstelle',
  by: 'intigoo'
}, {
  label: 'Mobile Erfassung',
  by: 'kunde'
}, {
  label: 'Auswertungen',
  by: 'kunde'
}];
export function BacklogIllustration() {
  const step = useStepCycle(features.length + 2, 1000);
  const visible = Math.min(step, features.length);
  return <div className="absolute inset-0 p-6 xl:p-8 flex gap-3 xl:gap-5" data-id="element-15" data-mp="2toyx6xa7neuj">
      <div className="w-[40%] flex flex-col" data-id="element-16" data-mp="2yknt8qn0udm3">
        <p className="text-sm font-semibold text-primary mb-3" data-id="element-17" data-mp="32nkgiuniaxwd">
          Ihre Anforderung
        </p>
        <div className="flex-1 bg-white rounded-2xl shadow-sm p-3 grid grid-cols-2 grid-rows-3 gap-2" data-id="element-18" data-mp="37mdt8kuyykvh">
          {features.map((f, i) => {
          const moved = i < visible;
          return <div key={f.label} className={`rounded-xl flex items-center justify-center text-[11px] xl:text-xs font-medium text-center px-1.5 leading-tight transition-colors duration-300 ${moved ? 'border-2 border-dashed border-primary/15 text-transparent' : 'bg-primary text-white'}`} data-id="element-19" data-mp="2zggkjerwesu8" data-mpi={i}>
                {f.label}
              </div>;
        })}
        </div>
      </div>

      <div className="flex items-center pt-7" data-id="element-20" data-mp="3dfgacpr5ddrz">
        <ArrowRight className="w-5 h-5 text-primary/40" data-id="element-21" data-mp="3de584udcoe2z" />
      </div>

      <div className="flex-1 flex flex-col min-w-0" data-id="element-22" data-mp="38fvckinprbgu">
        <div className="flex items-center justify-between mb-3" data-id="element-23" data-mp="38f2avw3m3c5k">
          <p className="text-sm font-semibold text-primary" data-id="element-24" data-mp="9shbatdaoagz">Backlog</p>
          <span className="text-xs text-text-secondary" data-id="element-25" data-mp="4zwjfxdy87g3">
            {visible} Features
          </span>
        </div>
        <div className="flex-1 bg-white rounded-2xl shadow-sm p-3 flex flex-col gap-2 overflow-hidden" data-id="element-26" data-mp="1z9bgsnhapebk">
          <AnimatePresence initial={false} data-id="element-27" data-mp="2393ufeljqans">
            {features.slice(0, visible).map(f => <motion.div key={f.label} initial={{
            opacity: 0,
            x: -24,
            scale: 0.96
          }} animate={{
            opacity: 1,
            x: 0,
            scale: 1
          }} exit={{
            opacity: 0,
            transition: {
              duration: 0.15
            }
          }} transition={{
            duration: 0.3,
            ease: EASE_OUT
          }} className="flex items-center justify-between gap-2 rounded-lg bg-bg-alt px-3 py-1.5 xl:py-2" data-id="element-28" data-mp="1phpan5jte5fo">
                <span className="text-xs xl:text-sm font-medium text-primary truncate" data-id="element-29" data-mp="16lpgpp7a0rtg">
                  {f.label}
                </span>
                <span className={`shrink-0 text-[10px] xl:text-[11px] font-semibold px-2 py-0.5 rounded-full ${f.by === 'intigoo' ? 'bg-primary text-white' : 'bg-accent text-primary'}`} data-id="element-30" data-mp="30x47m9c0wxas">
                  {f.by === 'intigoo' ? 'INTIGOO!' : 'Ihr Team'}
                </span>
              </motion.div>)}
          </AnimatePresence>
        </div>
      </div>
    </div>;
}